import {createAction} from 'redux-actions'
import * as ActionTypes from './actionTypes'
import {createActionObject} from '../../redux/utils'
import {addTasks, handleCommonTaskUpdateErrors, savePageSettings,} from "../common/actions"
import rpcCall from "../../util/rpc/rpcCalls"
import messageResource from "../../messageResource"
import {getTask, getWorkflowStatuses, getWorkflowStatusesArray} from "../../entities/selectors"
import * as SyncCallbacks from "./syncCallbacks"
import {setTypesOfWorkList} from '../../entities/actions'
import {getVisibleTableTaskIds} from './selectors'
import {arrayToSet} from '../../atUtils'
import {changeAllTasksSelected as commonChangeAllTasksSelected} from '../taskSelection/actions'
import {taskFromRpc} from '../utils'
import ClassicBridge from '../../next/ClassicBridge'
import { fillNextDataParams } from './connector'
import { getCustomFieldsFilters, getIntersectedCPSelection, getTaskNameFilter, getTaskStatusFilter, isShowOnlyManageableTasks } from '../common/selectors'
import {convertVariance, mergeClassicAndNextTask, nextDurationToMinutes} from '../../next/utils'
import _ from "underscore"
import { PRIORITY_FIELD_NAME } from '../constants'

export const setColumnsOrder = createAction(ActionTypes.COLUMNS_ORDER_SET)

export const setColumnsShown = createAction(ActionTypes.COLUMNS_SHOWN_SET)

export const setIsSummaryRowShown = createAction(ActionTypes.IS_SUMMARY_ROW_SHOWN_SET)

export const setLoadedTaskIds = createAction(ActionTypes.LOADED_TASK_IDS_SET)
export const addLoadedTaskIds = createAction(ActionTypes.LOADED_TASK_IDS_ADD)
const prependLoadedTaskIds = createAction(ActionTypes.LOADED_TASK_IDS_PREPEND)

export const addRecentlyCreatedTasks = (ids) => prependLoadedTaskIds(ids)

export const changeTasksSortingAction = (sorting) => (dispatch) => {
    dispatch(createActionObject(ActionTypes.TASKS_SORTING_CHANGE, sorting))
    dispatch(setLoaded(false))
    dispatch(savePageSettings())
}

export const changeAllTasksSelectedAction = () => (dispatch, getState) => {
    dispatch(commonChangeAllTasksSelected(arrayToSet(getVisibleTableTaskIds(getState()))))
}

export const setLoaded = createAction(ActionTypes.IS_LOADED_SET)
export const setSummaryRowIsLoaded = createAction(ActionTypes.IS_SUMMARY_ROW_LOADED_SET)


const setSummaryRow = createAction(ActionTypes.SUMMARY_ROW_SET)

export const updateSummaryRow = () => (dispatch, getState) => {
    const state = getState()
    const params = {
        customFieldsFilters: getCustomFieldsFilters(state)
    }

    fillNextDataParams({
        intersectedCPSelection: getIntersectedCPSelection(state),
        taskStatusFilter: getTaskStatusFilter(state),
        taskNameFilter: getTaskNameFilter(state),
        showOnlyManageableTasks: isShowOnlyManageableTasks(state),
    }, {
        taskWorkflowStatuses: getWorkflowStatusesArray(state)
    })(params)

    dispatch(setSummaryRowIsLoaded(false))
    dispatch(setSummaryRow({}))

    return ClassicBridge.syncChangesFromClassic()
        .then(() => ClassicBridge.getTasksSummary(params)
            .then((result) => {
                dispatch(setSummaryRow({
                    taskCount: result.count,
                    spentTime: nextDurationToMinutes(result.spentTime),
                    estimate: result.estimate ? nextDurationToMinutes(result.estimate) : null,
                    variance: convertVariance(result.variance),
                    workflowstatuses: result.workflowStatuses,
                    active: result.active,
                    closestDeadline: result.closestDeadline,
                    lastTrackingDate: result.lastTrackingDate,
                    lastCreationDate: result.lastCreationDate,
                }))
            })
        ).finally(() => {
            dispatch(setSummaryRowIsLoaded(true))
        })
}



export const updateTaskTypeOfWork = (taskId, typeOfWorkId) => (dispatch, getState) => {
    const prevTask = getTask(getState(), taskId)
    rpcCall("TaskManagementService.updateTaskTypeOfWork", [taskId, typeOfWorkId],
        (rpcError) => {
            if (rpcError.getTextStatus() === "rpc_customException") {
                const exception = rpcError.getErrorThrown().exception
                switch (exception) {
                    case "com.actimind.actitime.services.taskManagement.TypeOfWorkDeletedException":
                        alert(messageResource.getMessage("billing_type.js.error_type_was_deleted"))
                        dispatch(setTypesOfWorkList(rpcError.getErrorThrown().typesOfWork))
                        SyncCallbacks.afterTaskUpdated(taskId)
                        return true
                    case "com.actimind.actitime.services.taskManagement.TypeOfWorkArchivedException":
                        alert(messageResource.getMessage("billing_type.js.error_type_was_archived"))
                        dispatch(setTypesOfWorkList(rpcError.getErrorThrown().typesOfWork))
                        SyncCallbacks.afterTaskUpdated(taskId)
                        return true
                    case "com.actimind.actitime.services.FeatureIsDisabledException":
                        alert(messageResource.getMessage("task.error.billing_types_off"))
                        window.location.reload()
                        return true
                    default:
                        return handleCommonTaskUpdateErrors(prevTask, exception, dispatch)
                }
            }
        })
        .then((rpcData) => Promise.all([rpcData, ClassicBridge.getTasksAfterModification([prevTask.id])]))
        .then(([rpcData, nextTasks]) => {
            let task = taskFromRpc(rpcData["task"])

            if (nextTasks) {
                task = mergeClassicAndNextTask(task, nextTasks[0])
            }

            task.spentTime = prevTask.spentTime // do not overwrite
            dispatch(addTasks([task]))
            SyncCallbacks.afterTaskUpdated(taskId)
        })
        .catch(() => {
            // error actions dispatched in error handler
        })
}

export const updateTaskCustomField = (taskId, fieldName, value) => (dispatch, getState) => {
    const task = getTask(getState(), taskId)
    ClassicBridge.patchTaskCustomField(task.nextId, fieldName, value)
          .then(() => {
              const taskCopy = _.clone(task)
              taskCopy.customFieldsValues = {
                  ...task.customFieldsValues,
                  [fieldName]: value
              }

              dispatch(addTasks([taskCopy]))
              SyncCallbacks.afterTaskUpdated(taskId)
          })
          .catch((err) => {
            if (!(err && err.body)) {
                alert(messageResource.getMessage('api.error.unexpected_error'))
                window.location.reload()
            }
            if (err.body.reason === "feature_disabled") {
                alert(messageResource.getMessage(fieldName === PRIORITY_FIELD_NAME
                    ? "task.list.error.prfi_feature_disabled"
                    : "task.list.error.cfi_feature_disabled"
                ))
                window.location.reload()
            }
            if (err.body.reason === "permission_denied") {
                alert(messageResource.getMessage('task.edit_popup.no_rights_to_manage_tasks'))
                window.location.reload()
            }
            const errDetail = err.body.details && err.body.details[0]
            if (errDetail && errDetail.name === 'priority' && errDetail.errorKey === 'enum_key.unknown') {
                alert(messageResource.getMessage('task.edit_popup.priority_not_exists'))
                window.location.reload()
            }
          })
}



// WEBPACK FOOTER //
// ./web/js/taskManagement/tasksTable/actions.js